import React from "react";
import { AnimatePresence, motion } from "motion/react";

export default function CheckInBurstOverlay({ show }) {
  const count = 16; // more rays = better feel
  const rays = Array.from({ length: count });

  return (
    <AnimatePresence>
      {show ? (
        <motion.div
          className="fixed inset-0 z-[80] pointer-events-none flex items-center justify-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          {/* optional dim/blur */}
          <div className="absolute inset-0 bg-black/35 backdrop-blur-[2px]" />

          {/* center glow */}
          <motion.div
            className="absolute h-40 w-40 rounded-full bg-cyan-400/25 blur-3xl"
            initial={{ scale: 0.6, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.85, opacity: 0 }}
            transition={{ duration: 0.35 }}
          />

          {/* rays */}
          {rays.map((_, i) => (
            <motion.div
              key={i}
              className="absolute h-[3px] w-[min(90vw,1100px)] rounded-full"
              style={{
                rotate: `${(360 / count) * i}deg`, // ✅ rotate prop, not transform string
                background:
                  "linear-gradient(to right, rgba(34,211,238,0), rgba(34,211,238,0.75), rgba(59,130,246,0.75), rgba(59,130,246,0))",
              }}
              initial={{ opacity: 0, scaleX: 0 }}
              animate={{ opacity: 1, scaleX: 1 }}
              exit={{ opacity: 0, scaleX: 0.7 }}
              transition={{ duration: 0.55, ease: "easeOut" }}
            />
          ))}
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}